<template>
    <div>
        <!--====== PAGE TITLE PART START ======-->
        <section class="page-title-area bg_cover" style="background-image: url(assets/images/detail.jpg);">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-content">
                            <h3 class="title">Médiathèques</h3>
                            <!-- <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a href="">Home</a></li>
                                    <li class="breadcrumb-item active" aria-current="page">pages</li>
                                    <li class="breadcrumb-item active" aria-current="page">CGU</li>
                                </ol>
                            </nav> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--====== PAGE TITLE PART ENDS ======-->

        <!--====== FAQ DESIGN PART START ======-->
        <section class="faq-design-area pb-120">
            <div class="container">
                <div class="row">
                    <div v-for="item in medias" :key="item.id" class="col-md-4">
                        <div v-if="item.source.includes('Image')">
                            <img :src="item.src" :alt="item.source" width="320" height="320">
                            <h5 class="text-center mt-2">{{ item.source }}</h5>
                        </div>
                        <div v-else>
                            <video width="320" height="320" controls>
                                <source :src="item.src">
                                Your browser does not support the video tag.
                            </video>
                            <h5 class="text-center mt-2">{{ item.source }}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--====== FAQ DESIGN PART ENDS ======-->

        <Patner :partner="partners" />
    </div>
</template>

<script>
import Patner from './layouts/Partner';
import axios from 'axios';
export default {
    components: {
        Patner
    },
    data() {
        return {
            api_url: String,
            medias: [],
            partners: [],
        }
    },
    created() {
        this.api_url = process.env.VUE_APP_URL;
        this.getParam();
    },
    methods: {
        getParam() {
            axios.get(this.api_url + 'media')
            .then(async res => {
                const collect = await res.data;
                if (collect.success) this.medias = collect.data;
            })
            .catch(err => console.log(err));

            axios.get(this.api_url + 'partner')
                .then(async res => {
                    const collect = await res.data;
                    if (collect.success) this.partners = collect.data;
                })
                .catch(err => console.log(err));
        },
    },
}
</script>

<style scoped="this api replaced by slot-scope in 2.5.0+">
    
</style>